module.exports = __webpack_public_path__ + "img/user-guide-flow-diagram.zh_tw.98b1588e.png";